<template>
  <div class="flex items-center space-x-2" :class="$route.params.partner_name ? 'justify-end' : 'justify-between'">
    <div class="flex w-full items-center space-x-2 sm:w-auto md:space-x-4">
      <!-- PARTNER STRATEGY SEARCH -->
      <form class="relative flex w-full flex-grow items-stretch rounded-md shadow-sm" v-if="$route.params.partner_name">
        <button
          @click.prevent="partnerSearch"
          class="bg-ontick-steel-100 text-ontick-carbon-900 hover:bg-ontick-steel-200 hover:text-ontick-blue-500 dark:bg-ontick-steel-700 dark:hover:bg-ontick-graphite-600 relative -ml-px inline-flex items-center space-x-2 rounded-l-lg px-4 py-1.5 pr-2 text-sm font-medium dark:text-gray-300"
        >
          <dl v-html="!submitted ? $icons.search : $icons.loading"></dl>
        </button>
        <input
          :value="getPartnerSearchTerm"
          @input="setPartnerSearchTerm($event.target.value)"
          type="search"
          placeholder="Pesquisar"
          class="bg-ontick-steel-100 text-ontick-carbon-900 placeholder-ontick-carbon-900 hover:bg-ontick-steel-200 hover:text-ontick-blue-500 dark:bg-ontick-steel-700 dark:hover:bg-ontick-graphite-600 block h-10 w-full rounded-none rounded-r-lg border-none pr-6 pl-2 text-sm dark:text-gray-300 dark:placeholder-gray-300"
        />
      </form>

      <!-- MARKETPLACE SEARCH -->
      <div class="relative flex flex-grow items-stretch rounded-md shadow-sm" v-else>
        <button
          @click="setSearchChars(search)"
          class="bg-ontick-steel-100 text-ontick-carbon-900 hover:bg-ontick-steel-200 hover:text-ontick-blue-500 dark:bg-ontick-steel-700 dark:hover:bg-ontick-graphite-600 relative -ml-px inline-flex items-center space-x-2 rounded-l-lg px-4 py-1.5 pr-2 text-sm font-medium dark:text-gray-300"
        >
          <dl v-html="!submitted ? $icons.search : $icons.loading"></dl>
        </button>
        <input
          @keydown.enter="setSearchChars($event.target.value)"
          @blur="setSearchChars($event.target.value)"
          id="marketplace_search"
          v-model="search"
          type="search"
          placeholder="Pesquisar"
          class="bg-ontick-steel-100 text-ontick-carbon-900 placeholder-ontick-carbon-900 hover:bg-ontick-steel-200 hover:text-ontick-blue-500 dark:bg-ontick-steel-700 dark:hover:bg-ontick-graphite-600 block h-10 w-full rounded-none rounded-r-lg border-none pr-6 pl-2 text-sm dark:text-gray-300 dark:placeholder-gray-300"
        />
      </div>
    </div>
    <div class="flex items-center justify-end space-x-4" v-if="!$route.params.partner_name">
      <ontick-button
        v-if="$route.name !== 'Analistas XP'"
        content="Favoritos"
        @click.native="$emit('favorite'), (buttons.favorite = !buttons.favorite)"
        class="relative space-x-2 py-2"
        size="small"
        color="cinza"
      >
        <i v-html="$icons.favorite_sm" />
        <span class="hidden sm:block">Favoritos</span>
        <span v-show="favorite_marketplace.length > 0" class="badge">{{ favorite_marketplace.length }}</span>
      </ontick-button>

      <ontick-button
        content="Filtros"
        @click.native="$emit('order'), (buttons.order = !buttons.order)"
        class="relative space-x-2 py-2"
        size="small"
        color="cinza"
      >
        <i v-html="$icons.filter_sm" />
        <span class="hidden sm:block">Filtrar</span>
        <span v-show="getActiveFilters.length > 0" class="badge">{{ getActiveFilters.length }}</span>
      </ontick-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import OntickSwitchComponent from "../../../../shared/components/basic/ontick-switch.component.bkp.vue";
import EventBus from "@/app/shared/utils/event_bus.js";

export default {
  name: "menuTopMarketplace",

  components: {
    OntickSwitchComponent,
  },

  props: {
    table: {
      type: Boolean,
    },
    filter: {
      type: Array,
    },
    showRanking: {
      type: Boolean,
    },
  },

  data() {
    return {
      showSpinner: false,

      search: "",
      partnerSearchInput: "",
      submitted: false,

      optionDefault: {
        label: "Ordenar",
      },
      optionDefaultIcon: {
        label: `<svg class="w-6 h-6 text-ontick-button" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path></svg>`,
      },
      optionsSelect: [
        {
          label: "Ativo A a Z",
          type: "asc",
          criterion: "alpha",
        },
        {
          label: "Ativo Z a A",
          type: "desc",
          criterion: "alpha",
        },
        {
          label: "Maior Retorno",
          type: "desc",
          criterion: "return",
        },
        {
          label: "Menor Retorno",
          type: "asc",
          criterion: "return",
        },
        {
          label: "Maior Fator de Lucro",
          type: "desc",
          criterion: "profit_factor",
        },
        {
          label: "Menor Fator de Lucro",
          type: "asc",
          criterion: "profit_factor",
        },
        {
          label: "Maior Drawdown",
          type: "desc",
          criterion: "drawdown",
        },

        {
          label: "Menor Drawdown",
          type: "asc",
          criterion: "drawdown",
        },
        {
          label: "Maior Tx. Acerto",
          type: "desc",
          criterion: "win_ratio",
        },
        {
          label: "Menor Tx. Acerto",
          type: "asc",
          criterion: "win_ratio",
        },
      ],

      buttons: {
        order: false,
        favorite: false,
      },
    };
  },

  computed: {
    ...mapState({
      favorite: (state) => state.marketplace.favorite,
      qtd_filter: (state) => state.marketplace.qtd_filter,
      favorite_marketplace: (state) => state.marketplace.favorite_marketplace,
    }),
    ...mapGetters({
      getListMode: "marketplace/getListMode",
      getActiveFilters: "marketplace/getActiveFilters",
      getPartnerSearchTerm: "marketplace/getPartnerSearchTerm",
    }),
  },
  methods: {
    ...mapActions({
      orderMarketplace: "marketplace/orderMarketplace",
      getMarketplaceInputSearch: "marketplace/getMarketplaceInputSearch",
      getMarketplace: "marketplace/getMarketplace",
      getMarketplaceFavorite: "marketplace/getMarketplaceFavorite",
      setListMode: "marketplace/setListMode",
      clearActiveFilters: "marketplace/clearActiveFilters",
      getMarketplace: "marketplace/getMarketplace",
      setPartnerSearchTerm: "marketplace/setPartnerSearchTerm",
      setSearchChars: "marketplace/setSearchChars",
    }),

    log(event) {
      // console.log(event);
    },

    partnerSearch() {
      this.$emit("partner-strategy-search");
    },

    clearFilters() {
      this.getMarketplace("reset_filter");
      this.clearActiveFilters();
      this.$emit("show-ranking", true);
    },

    toggleVisualization() {
      this.showSpinner = true;
      setTimeout(() => {
        this.setListMode();
        this.showSpinner = false;
      }, 100);
    },
    searchMarketplace(value) {
      this.submitted = true;
      this.getMarketplaceInputSearch(value.toUpperCase());
      setTimeout(() => {
        this.submitted = false;
      }, 1000);
    },

    optionSelected(event, item) {
      this.orderMarketplace(event);
    },
  },

  mounted() {
    EventBus.$on("MARKETPLACE_CLEAR_ACTIVE_FILTERS", () => {
      this.search = "";
    });
    if (this.$route.query.hasOwnProperty("filter")) {
      this.search = this.$route.query.filter;
      this.searchMarketplace(this.$route.query.filter);
    }

    // reseta a busca ao clicar no X do campo de busca
    if (["Marketplace", "Analistas XP"].includes(this.$route.name)) {
      const searchInputElement = document.getElementById("marketplace_search");
      searchInputElement.addEventListener("search", (event) => {
        if (event.target.value === "") {
          this.setSearchChars("");
        }
      });
    }
  },
};
</script>
<style scoped>
.badge {
  @apply bg-ontick-green-500 text-ontick-graphite-500 absolute top-0 right-0 mt-1 ml-1 block h-4 w-4 -translate-y-1/2 translate-x-1/2 transform rounded-full text-xs font-semibold;
}
</style>
